import React from 'react';
import { Box, Container, Flex } from '@qga/roo-ui/components';

import {
  FLIGHT_DIRECTION,
  FlightDirection,
} from '../../../constants/flightDirection';
import DirectionTab from './components/DirectionTab';

export interface DirectionTabsProps {
  activeTab: FlightDirection;
  onTabClicked: (direction: FlightDirection) => void;
}

const DirectionTabs = React.memo(
  ({ activeTab, onTabClicked }: DirectionTabsProps) => (
    <Box bg="white" borderBottom="1px solid" borderColor="greys.alto">
      <Container px={[0, null, 3]}>
        <Flex justifyContent="center">
          <DirectionTab
            direction={FLIGHT_DIRECTION.Departing}
            isActive={activeTab === FLIGHT_DIRECTION.Departing}
            onTabClicked={() => onTabClicked(FLIGHT_DIRECTION.Departing)}
          />
          <Box m={1} />
          <DirectionTab
            direction={FLIGHT_DIRECTION.Returning}
            isActive={activeTab === FLIGHT_DIRECTION.Returning}
            onTabClicked={() => onTabClicked(FLIGHT_DIRECTION.Returning)}
          />
        </Flex>
      </Container>
    </Box>
  ),
);

export default DirectionTabs;
